export const getWrappedCardStyles = () => ({
  cardWrapper: ({ minWidth, widthPercentage, flexGrow }) => ({
    boxSizing: 'border-box',
    padding: [16, 8],
    display: 'flex',
    flexGrow,
    width: `${widthPercentage * 100}%`,
    minWidth,
  }),
});
